import { useToastProvider } from "@deere/fuel-react";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import FileDownloadedNotification from "./FileDownloadedNotification";
import JobsServiceApi from "../../../../../../../../api/jobsService/jobsServiceApi";
import { ConfigContext } from "../../../../../../../../context/ConfigContext";
import { Notification } from "../../hooks/useNotifications/useNotifications";

interface AllOrdersDownloadNotificationProps {
  notification: Notification;
  accountId: string;
  expireNotification: (notificationId: number) => void;
  downloadFile: (url: string, fileName: string) => void;
  successMessage: string;
  failureMessage: string;
}

const OrdersDownloadNotification = ({
  notification,
  accountId,
  expireNotification,
  downloadFile,
  successMessage,
  failureMessage,
}: AllOrdersDownloadNotificationProps) => {
  const { t, i18n } = useTranslation("common");
  const { JOBS_SERVICE_URL } = useContext(ConfigContext);
  const { enqueueToast } = useToastProvider();
  const downloadAllOrdersFile =
    (jobId: string, fileName: string) => (accessToken: string) => {
      JobsServiceApi.downloadAllOrdersAndOrderByLineItemExcel(
        JOBS_SERVICE_URL,
        jobId,
        accountId,
        fileName,
        accessToken,
        i18n.language
      )
        .then((response) => {
          downloadFile(URL.createObjectURL(response.data), fileName);
          expireNotification(new Date(notification.createdAt).getTime());
        })
        .catch(() =>
          enqueueToast({
            message: t("notifications.allOrders.download.failure.toast", {
              fileName: notification.payload.filename || "All Orders",
            }),
            variant: "error",
            isCloseable: true,
          })
        );
    };

  return (
    <FileDownloadedNotification
      notification={notification}
      successMessage={successMessage}
      failureMessage={failureMessage}
      downloadFunction={downloadAllOrdersFile(
        notification.payload.id,
        `${notification.payload.filename}.xlsx`
      )}
    />
  );
};

export default OrdersDownloadNotification;
